import React from "react";

const TabKpiRow = ({ cards = [] }) => (
  <div className="sta-tab-kpi-row">
    {cards.map((card) => (
      <div key={card.label} className={`sta-tab-kpi-card sta-tab-kpi-card--${card.mod}`}>
        <div className="sta-tab-kpi-card__label">{card.label}</div>
        <div className="sta-tab-kpi-card__value">{String(card.value)}</div>
        {card.sub && <div className="sta-tab-kpi-card__sub">{card.sub}</div>}
        {card.delta && (
          <div className={`sta-tab-kpi-card__delta ${card.delta.up ? "sta-delta--up" : "sta-delta--down"}`}>
            {card.delta.text}
          </div>
        )}
      </div>
    ))}
  </div>
);

export default TabKpiRow;
